import React from 'react';
import * as appHelpers from '@src/services/helpers/appHelpers';

import { FolderButton } from '@src/components/FolderButton';
import { classes, stylesheet } from 'typestyle';
import TuneIcon from '@mui/icons-material/Tune';

interface Props {
  unfold: boolean
  onUnfold: (unfold: boolean) => void
}

export function FilterTitle({ unfold, onUnfold }: Props) {
  function onClick() {
    onUnfold(!unfold);
    appHelpers.triggerResize();
  }

  return (
    <div className={sheet.header} onClick={onClick}>
      <div>
        <TuneIcon className={sheet.icon} />
        <span className={sheet.title}>Filter</span>
      </div>
      <div className={classes('right', sheet.fold)}>
        <FolderButton
          size={22}
          opened={unfold}
          direction="horizontal"
        />
      </div>
    </div>
  );
}

const sheet = stylesheet({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 20px',
    cursor: 'pointer',
  },
  title: {
    fontSize: 20,
    verticalAlign: 'middle',
  },
  icon: {
    marginRight: 9,
    verticalAlign: 'middle',
  },
  fold: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    marginRight: 2,
  },
});
